<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'Device',
})
</script>
<template>
  <a-card title="设备管理">
    <template  #extra>
        <lanseed-form-only ref="form" :data="searchVal" :rules="searchRule" :mode="false" @change="search">
          <template  #btn>
              <a-form-item>
              <a-button type="primary" v-if="auth.creating>0" @click="add"><PlusOutlined /> 新增设备 </a-button>
            </a-form-item>
          </template>
        </lanseed-form-only>
    </template>
    <a-table :dataSource="dataSource" :pagination="page"
    :loading="loading" :columns="columns" @change="pageChange" >
    <template #bodyCell="{ column, record,index }">
      <template v-if="column.key === 'AutoStart'">
          <a-switch :checked="record.AutoStart" />
      </template>
      <template v-if="column.key === 'CgUpload'">
          <a-switch :checked="record.CgUpload" />
      </template>
      <template v-if="column.key === 'DeviceGroupId'">
          {{ AutoData.FindName(datamodel,'DeviceGroupId',record.DeviceGroupId) }}
      </template>
      <template v-if="column.key === 'DeviceTypeEnum'">
          {{ AutoData.FindName(datamodel,'DeviceTypeEnum',record.DeviceTypeEnum) }}
      </template>

      <template v-if="column.key === 'operation'">
        <a-button-group>
            <a-button  v-if="auth.see>0" size="small" type="primary" @click="detail(record)">
               <ExceptionOutlined /> 详情
            </a-button>
            <a-button  v-if="auth.creating>0" size="small" type="primary" @click="restart(record,index)">
                <RetweetOutlined /> 重启
            </a-button>
            <a-button  v-if="auth.creating>0" size="small" type="primary" @click="edit(record,index)">
                <EditOutlined /> 修改
            </a-button>
            <a-button  v-if="auth.creating>0" size="small" type="primary" @click="editConf(record)">
                <EditOutlined /> 配置
            </a-button>
             <a-button  v-if="auth.creating>0" size="small" type="primary" @click="editVar(record)">
                <EditOutlined /> 变量
            </a-button>
            <a-button  v-if="auth.del>0"  size="small" type="primary" @click="del(record,index)">
                <DeleteOutlined /> 删除
            </a-button>
          </a-button-group>
      </template>
    </template>
    </a-table>
    <lanseed-form  v-model:open="formshow" :data="formModel" :rules="formRole"  @change="submit"></lanseed-form>
    <template v-if="actModel">
      <a-modal :footer="null" :destroyOnClose="true" v-model:open="showConf" width="80%" :title="actModel.DeviceName+' - 配置'">
        <div style="height: 70vh;overflow-y: auto;">
          <deviceconfig :DeviceId="actModel.ID" :auth="auth"></deviceconfig>
        </div>
      </a-modal>
  </template>
  <template v-if="actModel">
      <a-modal :footer="null" :destroyOnClose="true" v-model:open="showVar" width="80%" :title="actModel.DeviceName+' - 变量'">
        <div style="height: 70vh;overflow-y: auto;">
          <devicevar :DeviceId="actModel.ID" :auth="auth"></devicevar>
        </div>
      </a-modal>
  </template>
  <template  v-if="actModel">
      <a-modal :footer="null" :destroyOnClose="true" v-model:open="showDetail" width="80%" :title="actModel.DeviceName+' - '+actModel.DeviceNo">
        <div style="height: 70vh;overflow-y: auto;">
            <devicedetail :DeviceId="actModel.ID" :auth="auth"></devicedetail>
        </div>
      </a-modal>
  </template>
  </a-card>
</template>
<script setup lang="ts" name="Device">
import api from '@/utils/http/service'
import LanseedFormOnly from '@/components/lanseed/formonly.vue'
import LanseedForm from '@/components/lanseed/form.vue'
import {onMounted,defineProps,ref,watch,reactive,createVNode,defineComponent} from 'vue'
import { PlusOutlined,EditOutlined,DeleteOutlined,ExceptionOutlined,RetweetOutlined} from '@ant-design/icons-vue'
import { useRoute } from 'vue-router'
import {DefaultRule} from '@/router/types'
import { AutoData } from '@/utils/util'
import deviceconfig from './component/deviceconfig.vue'
import devicevar from './component/devicevar.vue'
import devicedetail from './component/devicedetail.vue'
import { union } from 'xe-utils'
import { message } from 'ant-design-vue'

  const auth:any=api.auth()
  const datamodel=ref<any>()//原始数据类型
  const drivers=ref<Array>()//驱动列表
  const groups=ref<Array>()//组列表
  const showVar=ref<Boolean>(false)
  const showConf=ref<Boolean>(false)
  const showDetail=ref<Boolean>(false)

  const actModel=ref<Object>()

  onMounted(()=>{

    api.device.model().then(res=>{
      if(res.state==1){
        datamodel.value=AutoData.InitModel(res.data)
        columns.value=AutoData.GetTableModel(datamodel.value,['DeviceTypeEnum','DeviceName','DriverName','DeviceGroupId','AutoStart','CmdPeriod'])
        var role=AutoData.GetFormModel(datamodel.value,[ 'DeviceName','DeviceType','DeviceGroupId','AutoStart','Description','Sort'])
        role.DeviceGroupId.required=true
        role.DeviceGroupId.domtype='select'
        role.Sort.required=true
        role.Sort.domtype='number'
        role.DeviceName.required=true
        role.DeviceType.required=true
        role.DeviceType.domtype="select"
        formRole.value=role
        getList()
      }
    })

  })
const searchVal:Record=ref({
  keyword:'',stime:'',etime:'',pay:''
})
const searchRule:Record=ref({
  keyword:{name:'关键字'}
})
const columns=ref<Array<object>>()
  const page=ref<PageData>({
    current:1,
    pageSize:10,
    pageFlag:true,
    total:0,
    pageStatus:'more',
    currentKey: 'pageIndex',
    pageSizeKey: 'pageSize',
  })
  const search=(e):void=>{
    searchVal.value=e
    page.value.current=1
    getList()
  }

  const loading=ref<boolean>(false)
  const dataSource=ref<Array<any>>([])
  const getList=():void=>{
    loading.value=true
      api.device.list({pageIndex:page.value.current,pageSize:page.value.pageSize,...searchVal}).then(res => {
        loading.value=false
        dataSource.value=res.data.data
        page.value.total=res.data.records
        page.value.current=res.data.pageIndex
      })
  }
  const pageChange=(e:anly)=>{
    page.value=e
    getList()
  }

const formModel:Record=ref({})
const formRole=ref({})
const formshow=ref<Boolean>(false)
const add=()=>{
    formModel.value=AutoData.GetDefaltModel(datamodel.value,{DeviceTypeEnum:0,AutoStart:false,CgUpload:false,ID:0,Sort:0,DriverId:null})
  formshow.value=true
}
const edit=(d,i)=>{
  formModel.value=AutoData.GetDefaltModel(datamodel.value,d)
  formshow.value=true
}
const del=(d,i)=>{
   api.device.del(d.ID).then(res=>{
    if(res.state==1){
       dataSource.value.splice(i,1)
    }
   })
}
const restart=(d,i)=>{
  api.device.restart(d.ID).then(res=>{
    if(res.state==1&&res.data==true){
      message.success('设备重启成功')
    }
  })
}
const detail=(d:any)=>{
  actModel.value=d
  showDetail.value=true
}

const submit=(e:any)=>{
  api.device.add(e).then(res=>{
    if(res.state==1){
      formshow.value=false
      getList()
    }
  })
}

const editConf=(d)=>{
  actModel.value=d
  showConf.value=true
}
const editVar=(d)=>{
  actModel.value=d
  showVar.value=true
}

</script>
